<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true ? 'WishLists' : 'Deleted wishlists'
                "
              ></h3>
              <!-- <template v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/wishlists/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </template> -->
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    clearable
                    @click:clear="(filter.is_active = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="285"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-start sr_no">Sr No</th>
                      <th class="text-start">Status</th>
                      <th class="text-start" style="min-width: none">
                        User Name
                      </th>
                      <th class="text-start">Product</th>

                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="wish_lists.length != 0">
                    <tr
                      v-for="(wish, i) in wish_lists"
                      :key="`wish_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': wish.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="wish.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>wishlist is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="wish.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Position is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{ wish.user ? wish.user.first_name : "N/A" }}
                      </td>
                      <td>
                        {{ wish.product ? wish.product.name : "N/A" }}
                      </td>
                      <!-- <td>
                        {{ userEmailMap[wish.user_id] || "N/A" }}
                      </td>

                      <td>{{ productNameMap[wish.product_id] || "N/A" }}</td> -->

                      <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="askDelete(wish.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this record</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(wish.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this unit</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="7" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_wish" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>units deleted successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_deleted_wish = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_wish" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Unit restored successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_restored_wish = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>

    <!-- Delete confirmation -->
    <ConfirmationDialog
      :show.sync="deleteDialog"
      title="Delete Wishlist"
      message="Are you sure you want to delete this wishlist entry? This action cannot be undone."
      icon="mdi-delete"
      color="error"
      :loading="delete_wish"
      @confirm="Delete_this(pendingDeleteId)"
    />
  </v-main>
</template>

<script>
import axios from "axios";
import ConfirmationDialog from "@/components/ConfirmationDialog.vue";
export default {
  name: "UnitsPage",
  components: { ConfirmationDialog },
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        show_deleted: false,
      },
      users: [],
      userEmailMap: {},
      products: [],
      productNameMap: {},

      wish_lists: [],
      statuses: [
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],

      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      isLoading: false,
      isExcelloading: false,
      delete_wish: false,
      is_deleted_wish: false,
      restore_wish: false,
      is_restored_wish: false,
      deleteDialog: false,
      pendingDeleteId: null,
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
    // this.getMasters();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&search_keyword=" +
        this.filter.search_keyword;

      await axios
        .get(`wishlists?${query}`)
        .then((response) => {
          this.wish_lists = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },

    async getMasters() {
      try {
        const response = await axios.get("wishlists/masters");
        const { users, products } = response.data;

        if (users) {
          this.users = users; // Store the users data
          this.userEmailMap = users.reduce((map, user) => {
            map[user.id] = user.email; // Map user_id to user_email
            return map;
          }, {});
        } else {
          this.$toast.error("No users found.");
        }

        if (products) {
          this.products = products; // Store the products data
          this.productNameMap = products.reduce((map, product) => {
            map[product.id] = product.name; // Map product_id to product_name
            return map;
          }, {});
        } else {
          this.$toast.error("No products found.");
        }
      } catch (error) {
        this.$toast.error("Failed to fetch master data.");
        console.error("Error fetching master data:", error);
      }
    },

    askDelete(id) {
      this.pendingDeleteId = id;
      this.deleteDialog = true;
    },
    async Delete_this(id) {
      this.delete_wish = true;
      await axios
        .post(`/wishlists/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.is_deleted_wish = true;
          this.deleteDialog = false;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          //   findwindow.location.href = "/auth/login";
        })
        .finally(() => {
          this.delete_wish = false;
        });
    },
    async Restore_this(id) {
      this.restore_position = true;
      await axios
        .post(`/wishlists/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_wish = false;
          this.is_restored_wish = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
  },
};
</script>
